(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("textbox", [], factory);
	else if(typeof exports === 'object')
		exports["textbox"] = factory();
	else
		root["textbox"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 